<template>
  <div>
    <BasicNavigation></BasicNavigation>
  </div>
  <div class="flex flex-col items-center min-h-screen bg-white py-10">
    <div class="w-full max-w-2xl">
      <div class="text-2xl font-bold leading-6 text-pdsPrimaryColor flex-1 mx-2 pb-4">Registreren</div>
      <card>
        <div class="mt-4 flex items-center">
          <CheckIcon class="h-6 w-6 text-pdsPrimaryColor" />
          <div class="text-xl font-bold text-pdsPrimaryColor ml-2">Uw registratie is voltooid</div>
        </div>
        <div class="mt-4">
          <p class="text-l font-semibold text-gray-700 mt-2">
            Wij verwachten uw registratie binnen <span class="font-bold text-gray-700">2 werkdagen</span> te hebben
            verwerkt. U ontvangt dan een definitieve bevestiging van uw registratie per e-mail.
          </p>
        </div>
        <button
          type="button"
          @click.prevent="redirectToLogin()"
          class="border border-pdsPrimaryColor text-pdsPrimaryColor font-semibold py-2 px-4 rounded-full"
        >
          <span class="flex items-center justify-center gap-2">
            <span>Terug naar Inloggen</span>
            <ArrowUturnLeftIcon class="w-5 h-5" />
          </span>
        </button>
      </card>
    </div>
  </div>
</template>
<script>
import { ArrowUturnLeftIcon, CheckIcon } from '@heroicons/vue/20/solid';
import BasicNavigation from '@/components/webcomponents/BasicNavigation';
import router from '@/router';

export default {
  name: 'AccountRegistrationSuccess',
  components: {
    ArrowUturnLeftIcon,
    CheckIcon,
    BasicNavigation
  },

  setup() {},
  created() {},
  methods: {
    redirectToLogin() {
      router.push('/inloggen');
    }
  }
};
</script>
